module.exports = __webpack_public_path__ + "static/media/bv.837ccf74.svg";